import React from "react";
import PropTypes from "prop-types";
import Dialog from "./Dialog";
import withRequests from "../utils/withRequests";
import FileContent from "./FileContent";

/**
 * File dialog
 * @module
 * @param {bool} isOpen - Is dialog open?
 * @param {func} onClose - Function invoked on dialog close
 * @param {object} [column] - Column
 * @param {object} [dataItem] - Data item
 */
const FileDialog = (props) => {
  const { dataItem, column, onClose, isOpen, requests } = props
  
  return (
    <Dialog title="Príloha" onClose={onClose} isOpen={isOpen} fullscreen>
      <React.Fragment>
        {dataItem && (
          <FileContent
            style={{ margin: 20 }}
            requests={requests}
            name={column.name || dataItem[column.nameField]}
            url={column.url.replace("{id}", dataItem[column.idField])}
            mimeType={column.mimeType || dataItem[column.mimeTypeField]}
            id={dataItem[column.idField]}
          />
        )}
      </React.Fragment>
    </Dialog>
  );
};

FileDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  column: PropTypes.object,
  dataItem: PropTypes.object,
};

export default withRequests(FileDialog);
